import { render, staticRenderFns } from "./UiListGroups.vue?vue&type=template&id=053ccb4c&"
import script from "./UiListGroups.vue?vue&type=script&lang=js&"
export * from "./UiListGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports